import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Col, Row, Portlet, Button, Form } from '_zari/core'

import { DownloadAxiosFile } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'
import ValidationSchema from './validacion'

const ReporteEstandar = () => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      _idUsuario: '',
      _idSede: '',
      fechaInicio: '',
      fechaFin: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      __zariContext.loader.open('Descargando reporte de cobranzas')

      AsientoContableService.descargarReporteCobranzasxFechaxUsuario(data)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
          __zariContext.toast('success', 'Reporte descargado satisfactoriamente.')
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          __zariContext.loader.close()
          setSubmitting(false)
        })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header title='Reporte de Cobranzas' />
      <Portlet.Body>
        <Formik initialValues={formInitialValues} onSubmit={onSubmit} validationSchema={ValidationSchema}>
          {({ errors, touched, isSubmitting, setFieldValue, handleSubmit }) => (
            <Form>
              <FormGroups.SedeFormGroup
                iError={errors._idSede}
                iTouched={touched._idSede}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.UsuarioFormGroup
                iError={errors._idUsuario}
                iTouched={touched._idUsuario}
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
              />
              <FormGroups.FechaInicioFormGroup
                iError={errors.fechaInicio}
                iTouched={touched.fechaInicio}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.FechaFinFormGroup
                iError={errors.fechaFin}
                iTouched={touched.fechaFin}
                fIsSubmitting={isSubmitting}
              />
              <Row>
                <Col md={12} className='text-right'>
                  <Button id='button-reporteCobranzas-submit' disabled={isSubmitting} onClick={handleSubmit}>
                    Descargar
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ReporteEstandar)
